import React from 'react';
import ValidationInput from "../common/ValidationInput";
import {email, minLength, required} from "../../functions/validationRules";
import {Field, reduxForm} from "redux-form";
import {centerChildStyle} from "../SsoLink/styles/SsoLinkForm.css";
import Button from "../common/Button";
import {connect} from "react-redux";

const minLength8 = minLength(8);

export const SsoLinkForm = props => {


  const buttonIsDisabled = () => {
    const {
      email,
      password
    } = props.values;

    return !(
      email.length > 0 &&
      password.length > 0 &&
      !props.fields.errors
    );
  };


  return (
    <form>
      <div className="row justify-content-center">
        <div className="col-md-12" style={centerChildStyle}>
          <Field
            className="form-control input-lg"
            type="text"
            name="email"
            label="Email"
            component={ValidationInput}
            validate={[required, email]}
            val={props.values.email}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={centerChildStyle}>
          <Field
            className="form-control input-lg"
            type="password"
            name="password"
            label="Password"
            component={ValidationInput}
            validate={[required, minLength8]}
            val={props.values.password}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={centerChildStyle}>
          {props.apiError}
        </div>
      </div>
      <div className="row">
        <div className="col-md-12" style={centerChildStyle}>
          <Button
            classNames={["btn-lg"]}
            text="Link Account"
            large={true}
            action={props.handleSubmit}
            disabled={buttonIsDisabled()}
          />
        </div>
      </div>
    </form>
  );
};

export const mapStateToProps = state => {
  let values2 = {
    email: '',
    password: ''
  };

  let fields2 = {
    emailTouched: false,
    passwordTouched: false,
    errors: true
  };

  if (state.form.SsoLink) {
    const {values, fields} = state.form.SsoLink;

    if (values) {
      values2 = {
        email: values.email || '',
        password: values.password || ''
      };
    }
    if (fields) {
      fields2 = {
        emailTouched: fields.email && fields.email.touched ? true : false,
        passwordTouched:
          fields.password && fields.password.touched ? true : false,
        errors: state.form.SsoLink.syncErrors ? true : false
      };
    }
  }

  return {
    values: values2,
    fields: fields2
  };
};

const mapDispatchToProps = dispatch => ({});

export default reduxForm({
  form: 'SsoLink'
})(connect(mapStateToProps, mapDispatchToProps)(SsoLinkForm));
